import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'landing/layouts/Main';
import Container from 'components/Container';
import { UpcomingTournaments, PastTournaments } from './components';
import { AccountCard } from 'components/Cards';
import Hero from './components/Hero';

const TournamentsPage = () => {
  const theme = useTheme();

  return (
    <Main>
      <Hero />
      <Container
        sx={{
          paddingBottom: {
            sm: '80px !important',
            md: '96px !important',
          },
          paddingTop: {
            sm: '80px !important',
            md: '96px !important',
          },
        }}
      >
        <UpcomingTournaments />
      </Container>
      <Box
        sx={{
          background: '#F5F6F7',
        }}
      >
        <Container
          sx={{
            paddingBottom: {
              sm: '80px !important',
              md: '96px !important',
            },
            paddingTop: {
              sm: '80px !important',
              md: '96px !important',
            },
          }}
        >
          <PastTournaments />
        </Container>
      </Box>
      <Container>
        <AccountCard />
      </Container>
    </Main>
  );
};

export default TournamentsPage;
